import React from 'react'
import styled from 'styled-components'
import { getPath as getDPath } from './characters/D'
import { getPath as getNPath } from './characters/N'
import { getPath as getPPath } from './characters/P'
import { getPath as getSPath } from './characters/S'
import { getPath as getTPath } from './characters/T'
import { getPath as getExclamationMarkPath } from './characters/ExclamationMark'

const Stop1 = styled.stop`
  stop-color: var(--brandColor1);
`

const Stop2 = styled.stop`
  stop-color: var(--brandColor2);
`

const Logo = () => (
  <svg viewBox="0 0 2350 2350" xmlns="http://www.w3.org/2000/svg">
    <title>Insipid Studio</title>
    <defs>
      <linearGradient id="logo" x1="100%" y1="0%" x2="0%" y2="100%">
        <Stop1 offset="0%" />
        <Stop2 offset="100%" />
      </linearGradient>
    </defs>
    <path
      d={[
        ...getNPath(0, 0),
        ...getSPath(600, 0),
        ...getPPath(1200, 0),
        ...getDPath(1800, 0),
        ...getSPath(0, 1200),
        ...getTPath(600, 1200),
        ...getDPath(1200, 1200),
        ...getExclamationMarkPath(1800, 1200)
      ].join(' ')}
      fill="url(#logo)"
    />
  </svg>
)

export default Logo
